<template>
<div class="calcform">
    <div class="container">
        <h2>ISPLATI LI SE FOTONAPONSKA ELEKTRANA ZA VLASTITU POTROŠNJU?</h2>
        <h3>
            ALAT ZA PROCJENU INVESTICIJE U
            FOTONAPONSKU ELEKTRANU ZA VLASTITU POTROŠNJU
        </h3>
        <!--<div class="obavezno">* Svi podaci su obavezni</div>-->

        <div class="tekst">
            <p>
                Obnovljivi izvori energije svakako doprinose borbi protiv klimatskih promjena,
                no kakva je zapravo njihova isplativost, da li je moguće da pored toga što proizvode
                „zelenu energiju“ i čuvaju okoliš oni istovremeno su profitabilni?
                Pođite s nama na ovo zanimljivo putovanje i saznajte prednosti zbog kojih
                ćete se još se odlučiti za investiciju u fotonaponsku elektranu za vlastitu potrošnju.
            </p>
            <div class="buttonWrap">
                <button class="accordion border-1" type="button" @click="
            (ev) => {
              ev.currentTarget.classList.toggle('active');
            }
          ">
                    O čemu se tu zapravo radi?
                </button>
                <div class="panel">
                    <p>
                        Alat za procjenu investicije u fotonaponsku elektranu za vlastitu potrošnju omogućit će potencijalnim investitorima sagledavanje financijskog aspekta poslovnog poduhvata te dati informaciju o isplativosti investicije. U alat će biti ugrađeno iskustvo tvrtke OM Projekt stečeno na projektima u području obnovljivih izvora energije, a omogućit će informiranje i educiranje potencijalnih investitora o parametrima bitnim za procjenu isplativosti investicije, kao i pružiti tehničku potporu prilikom donošenja poslovne odluke. Alat će biti osnova razvoja daljnjih rješenja u području obnovljivih izvora energije.
                    </p>
                    <p>
                        Svrha predmetnog projekta je formalizirati znanje i iskustvo koje postoji u oblik koji će omogućiti izradu matematičkog modela alata za procjenu isplativosti investicije u fotonaponsku elektranu za vlastitu potrošnju, temeljem niza tehno-ekonomskih parametara i postojećeg iskustva tvrtke te time pružiti potporu potencijalnom investitoru prilikom donošenja odluke o investiciji, odnosno predstavljat će podlogu za razvoj slijednih aplikacija u području OIE, što će u razdoblju koje slijedi imati sve veću ulogu prilikom procesa dekarbonizacije u sklopu energetske tranzicije ka niskougljičnom društvu.
                    </p>
                </div>
            </div>
        </div>

        <form @submit.prevent="validate">
            <ul class="flex-outer">
                <li>
                    <label for="snagaElektrane">Željena snaga elektrane [kW]</label>
                    <input type="number" class="form-control" id="snagaElektrane" min="0" v-model.number="snagaElektrane" placeholder="8" required />
                </li>
                <li>
                    <label for="procjenaTroskova">Procjena troškova bez PDV-a(kn)
                        <div class="box">
                            <span>
                                <span class="material-icons">help</span>
                                <div class="tooltip">Procjena troškova ovisi o željenoj snazi elektrane, a sadrži cijenu opreme, cijenu priključka na distribucijsku mrežu, izradu projektne dokumentacije te ostale troškove.</div>
                            </span>
                        </div>
                    </label>
                    <currency-input id="procjenaTroskova" v-model.number="procjena_troskova" readonly />
                </li>
                <li>
                    <label for="procjenaTroskova">Procjena troškova s PDV-om (kn)</label>
                    <currency-input id="procjenaTroskova" v-model.number="procjena_PDV" readonly />
                </li>
                <li>
                    <label for="potrebnaPovrsinaKrova">
                        Potrebna površina krova [m<sup>2</sup>]
                    </label>
                    <input id="potrebnaPovrsinaKrova" v-model="potrebnaPovKrova" readonly />
                </li>
                <li>
                    <label for="iskoristivaPovrsinaKrova">
                        Iskoristiva površina krova [m<sup>2</sup>]
                    </label>
                    <input type="number" class="form-control" id="iskoristivaPovrsinaKrova" min="0" v-model.number="iskoristivaPovKrova" placeholder="48" required />
                </li>
                <li v-if="krov == true" class="errors">
                    <span>*{{ krovText }}</span>
                </li>
                <li>
                    <label for="zakupljenaSnagaObjekta">
                        Zakupljena snaga objekta [kW]
                        <div class="box">
                            <span>
                                <span class="material-icons">help</span>
                                <div class="tooltip"><p>Broj unijeti s decimalnom točkom</p></div>
                            </span>
                        </div>
                    </label>
                    <input type="number" class="form-control" id="zakupljenaSnagaObjekta" min="0" step="0.01" v-model.number="zakSnagaObjekta" placeholder="13.8" required />
                </li>
                <li>
                    <label for="godPotrosnjaKucanstva">
                        Ukupna godišnja potrošnja kućanstva: [kWh/godišnje]
                    </label>
                    <input type="number" class="form-control" id="godPotrosnjaKucanstva" min="0" v-model.number="godPotrosnja" placeholder="7200" required />
                </li>
                <li>
                    <label for="ocekivanaEnergija">
                        Planirana godišnja proizvodnja [kWh/godišnje]
                        <div class="box">
                            <span>
                                <span class="material-icons">help</span>
                                <div class="tooltip">
                                    - Južna Hrvatska (Dalmacija) za 1 kW instalirane snage srednja vrijednost za proračun 1500 kWh proizvedeno <br>
                                    - Primorje (Sjeverni Jadran) za 1 kW instalirane snage srednja vrijednost za proračun 1380 kWh proizvedeno <br>
                                    - Gorska Hrvatska za 1 kW instalirane snage srednja vrijednost za proračun 960 kWh proizvedeno <br>
                                    - Središnja Hrvatska za 1 kW instalirane snage srednja vrijednost za proračun 1200 kWh proizvedeno <br>
                                    Izvor: <a href="https://ec.europa.eu/jrc/en/pvgis" target="_blank">https://ec.europa.eu/jrc/en/pvgis</a></div>
                            </span>
                        </div>
                    </label>
                    <input type="number" class="form-control" id="ocekivanaEnergija" min="0" v-model.number="ocek_kol_en" placeholder="6000" required />
                </li>
                <li>
                    <label for="procjenaSubvencije">
                        Odabir razine subvencije
                        <div class="box">
                            <span>
                                <span class="material-icons">help</span>
                                <div class="tooltip">
                                    Fond će Korisnicima dodjeljivati sredstva donacije do 75.000,00 kuna po prijavi, za opravdane troškove nabave i ugradnje jedne nove FNE (s PDV-om): <br>
                                    - do 80%, ali ne više od 75.000,00 kn na području posebne državne skrbi i na prvoj skupini otoka, <br>
                                    - do 60%, ali ne više od 56.250,00 kn na brdsko-planinskom području i na drugoj skupini otoka, <br>
                                    - do 40%, ali ne više od 37.500,00 kn na ostalim područjima RH <br>
                                    Iznos subvencije ne obuhvaća cijenu priključka.
                                </div>
                            </span>
                        </div>
                    </label>
                    <select class="form-control" id="procjenaSubvencije" v-model="odabranaSubvencija" required>
                        <option v-for="item in subvencijaOpcije" :key="item.id" :value="item.id">{{item.name}}</option>
                    </select>
                </li>
                <li>
                    <label for="iznosSub">
                        Iznos subvencije
                    </label>
                    <currency-input id="iznosSub" v-model.number="subvencija" readonly />
                </li>
                <li v-if="error == true" class="errors">
                    <span>*{{ errorText }}</span>
                </li>
                <li>
                    <label for="planiraniKredit">Planirani iznos kredita (kn)</label>
                    <currency-input class="form-control" id="planiraniKredit" placeholder="10000" :value-range="{ min: 0 }" v-model="iznos_kredita" required />
                </li>
                <li v-if="kredit == true" class="errors">
                    <span>*{{ kreditText }}</span>
                </li>
                <li>
                    <label for="kamatnaStopa">Kamatna stopa (%)</label>
                    <input type="number" class="form-control" step="0.1" id="kamatnaStopa" placeholder="2" min="0" v-model.number="kam_stopa" required />
                </li>
                <li>
                    <label for="rokOtplate">
                        Rok otplate [godina]
                        <div class="box">
                            <span>
                                <span class="material-icons">help</span>
                                <div class="tooltip"><p>Maksimalno razdoblje - 15 godina</p></div>
                            </span>
                        </div>
                    </label>
                    <input type="number" class="form-control" id="rokOtplate" placeholder="15" min="0" max="15" v-model.number="rok_otplate" required />
                </li>
                <li>
                    <label for="amortRazdoblje">
                        Amortizacijsko razdoblje [godina]
                        <div class="box">
                            <span>
                                <span class="material-icons">help</span>
                                <div class="tooltip"><p>Maksimalno razdoblje - 15 godina</p></div>
                            </span>
                        </div>
                    </label>
                    <input type="number" class="form-control" id="amortRazdoblje" placeholder="5" min="0" max="15" v-model="amort_razd" required />
                </li>
                <li>
                    <button type="submit">Izračunaj</button>
                </li>
            </ul>
        </form>
    </div>
    <div class="rezultat" v-if="doneCalculate">
        <div class="vrijednosti">
            <h2>Proračun</h2>
            <table>
                <thead>
                    <tr>
                        <th>Atribut</th>
                        <th>Vrijednost</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Odabrana snaga elektrane</td>
                        <td>{{snagaElektrane}} kWh</td>
                    </tr>
                    <tr>
                        <td>Trošak bez PDV-a</td>
                        <td>{{procjena_troskova | toCurrency}}</td>
                    </tr>
                    <tr>
                        <td>Subvencija</td>
                        <td>{{subvencija | toCurrency}}</td>
                    </tr>
                    <tr>
                        <td>Postotak subvencije</td>
                        <td>{{(subvencija / procjena_troskova * 100).toFixed(2)}} %</td>
                    </tr>
                    <tr>
                        <td>Ukupno (početno) ulaganje u projekt</td>
                        <td>{{procjena_troskova - subvencija | toCurrency}}</td>
                    </tr>
                    <tr>
                        <td>PDV</td>
                        <td>{{ uk_PDV | toCurrency}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td id="total" colspan="2">
                            Ukupno bruto:
                            <span class="space">{{ukupno | toCurrency}}</span>
                        </td>
                    </tr>
                </tfoot>
            </table>

            <div class="dobit">
                <h2>Omjer financiranja</h2>
                <table>
                    <thead>
                        <tr>
                            <th>Opis</th>
                            <th>Iznos</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Kredit banke</td>
                            <td>{{ iznos_kredita | toCurrency }}</td>
                            <td>{{ (iznos_kredita / ukupno * 100).toFixed(2) }} %</td>
                        </tr>
                        <tr>
                            <td>Vlastita sredstva</td>
                            <td>{{ ukupno - iznos_kredita | toCurrency }}</td>
                            <td>{{ ((ukupno - iznos_kredita) / ukupno * 100).toFixed(2) }} %</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="dobit">
            <h2>Kumulativ
                <div class="box">
                    <span>
                        <span class="material-icons">help</span>
                        <div class="tooltip">Godina u kojoj je kumulativ pozitivan predstavlja razdoblje povrata ulaganja. Projekt se smatra prihvatljivim ukoliko je ovo razdoblje u okviru ekonomskog vijeka projekta, a projekt je to prihvatljiviji što je razdoblje kraće. </div>
                    </span>
                </div>
            </h2>
            <column-chart xtitle="Godine" ytitle="Iznos" :data="povrat" :colors="['#f0ad4e', ]" height="500px" :stacked="false"></column-chart>
        </div>
        <div class="dobit">
            <h2>ROA
                <div class="box">
                    <span>
                        <span class="material-icons">help</span>
                        <div class="tooltip">eng. Return On Assets - predstavlja povrat od uložene imovine, pokazatelj rentabilnosti odnosno profitabilnosti imovine</div>
                    </span>
                </div>
            </h2>
            <column-chart xtitle="Godine" ytitle="Postotak" :data="roa" :colors="['#f0ad4e', ]" height="500px" :stacked="false" :discrete="false" suffix="%"></column-chart>
        </div>
        <div class="centerButton">
            <button @click="clearForm" class="clearButton">Očisti</button>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
export default {
    data() {
        return {
            snagaElektrane: null,

            cijena_oprema: null,
            cijena_priključak: 7000,
            cijena_dokumentacije: 5000,
            cijena_ostalo: 2500,

            procjena_troskova: null,
            procjena_PDV: null,

            potrebnaPovKrova: null,
            iskoristivaPovKrova: null,
            zakSnagaObjekta: null,
            godPotrosnja: null,
            ocek_kol_en: 6000,

            subvencija: null,
            odabranaSubvencija: null,
            subvencijaOpcije: [{
                    id: 1,
                    name: 'Do 80%, ali ne više od 75.000,00 kn'
                },
                {
                    id: 2,
                    name: 'Do 60%, ali ne više od 56.250,00 kn'
                },
                {
                    id: 3,
                    name: 'Do 40%, ali ne više od 37.500,00 kn'
                },
                {
                    id: 4,
                    name: '0%'
                }
            ],

            iznos_kredita: null,
            kam_stopa: null,
            rok_otplate: null,
            amort_razd: 15,
            ukupno: null,
            uk_bez_PDV: null,
            uk_PDV: null,

            cijena_otkupa: 0.9727,
            godisnja_usteda: null,
            troskoviOpskrbNeto: null,
            troskoviOpskrbBruto: null,
            razlikaZaNaplatu: null,

            god_amortizacija: null,
            doneCalculate: false,
            anuitet: 0,
            iznos_kamate_god: [],
            fin_rashodi: null,
            neto_dobit: [],
            ekonomicnost: [],
            EBIT: [],
            EBITDA: [],
            brutoProfMrez: [],
            netoProfMrez: [],
            ulaganje_imovina: [],
            dug: [],
            roa: [],
            povrat: [],
            nnt: [],
            dostatnostNNT: [],
            AAR: null,
            AARR: null,
            NPV: null,

            error: false,
            errorText: "Maksimalni iznos subvencije iznosi 91.250,00 kn ili 60 % investicije bez PDV-a",

            krov: false,
            krovText: "Iskoristivi dio krova mora biti veći ili jednak potrebnoj površini krova",

            kredit: false,
            kreditText: "Kredit je veći od iznosa koji se treba platiti",

            subvencija_postotak: null,
        };
    },

    methods: {
        calculateValues() {
            this.cijena_oprema = this.snagaElektrane * 6480;
            this.procjena_troskova = this.cijena_oprema +
                this.cijena_priključak + this.cijena_dokumentacije +
                this.cijena_ostalo;

            this.procjena_PDV = this.procjena_troskova * 1.25;

            this.potrebnaPovKrova = this.snagaElektrane * 6;
        },

        subvencijaIznos() {
            if (this.odabranaSubvencija === 1) {
                this.subvencija = ((this.procjena_troskova - this.cijena_priključak) * 0.8)
                if (this.subvencija > 75000) {
                    this.subvencija = 75000;
                }
            } else if (this.odabranaSubvencija === 2) {
                this.subvencija = ((this.procjena_troskova - this.cijena_priključak) * 0.6)
                if (this.subvencija > 56250) {
                    this.subvencija = 56250;
                }
            } else if (this.odabranaSubvencija === 3) {
                this.subvencija = ((this.procjena_troskova - this.cijena_priključak) * 0.4)
                if (this.subvencija > 37500) {
                    this.subvencija = 37500;
                }
            }else if(this.odabranaSubvencija === 4){
                this.subvencija = 0;
            }

        },

        provjeraKrova() {
            if (this.potrebnaPovKrova > this.iskoristivaPovKrova) {
                this.krov = true;
            } else {
                this.krov = false;
            }
        },

        provjeraKredita() {
            this.subvencija_postotak = this.subvencija / this.procjena_troskova;

            this.uk_PDV = (this.procjena_troskova - this.subvencija) * 0.25;
            this.ukupno = (this.procjena_troskova - this.subvencija) + this.uk_PDV;
            this.uk_bez_PDV = this.procjena_troskova - this.subvencija;

            if (this.iznos_kredita > this.ukupno) {
                this.kredit = true;
            } else {
                this.kredit = false;
                this.doneCalculate = false;
            }
        },

        validate() {
            if (this.error === false && this.krov === false && this.kredit === false && this.doneCalculate === false) {
                this.calculate();
            }
        },

        calculate() {

            this.provjeraKredita();

            let iznos = this.iznos_kredita;
            this.anuitet = this.PMT(((this.kam_stopa / 100)), this.rok_otplate, this.iznos_kredita);
            for (let i = 0; i < (this.rok_otplate); i++) {
                this.iznos_kamate_god.push((iznos * (this.kam_stopa / 100)));
                iznos = iznos - this.anuitet + this.iznos_kamate_god[i];
            }

            this.godisnja_usteda = this.ocek_kol_en * this.cijena_otkupa;
            this.troskoviOpskrbNeto = this.godPotrosnja * this.cijena_otkupa;
            this.troskoviOpskrbBruto = this.troskoviOpskrbNeto * 1.25;
            this.razlikaZaNaplatu = this.troskoviOpskrbNeto - this.godisnja_usteda;

            this.god_amortizacija =
                ((this.procjena_troskova - this.subvencija) / this.amort_razd);

            for (let i = 0; i < 15; i++) {
                if (i >= this.rok_otplate) {
                    //this.fin_rashodi.push(300 + this.god_amortizacija + 0 + this.troskoviOpskrbNeto);
                    this.neto_dobit.push(this.godisnja_usteda - (300 + this.god_amortizacija + 0)); // zadnje fin rashodi vjv ide cijela rata kredita, a ne samo kamata
                    this.EBIT.push(0 + this.neto_dobit[i] * 1.25); // prvo fin. rashodi kao i gore
                } else {
                    //this.fin_rashodi.push(300 + this.god_amortizacija + this.iznos_kamate_god[i] + this.troskoviOpskrbNeto);
                    this.neto_dobit.push(this.godisnja_usteda - (300 + this.god_amortizacija + this.iznos_kamate_god[i])); // zadnje fin rashodi vjv ide cijela rata kredita, a ne samo kamata
                    this.EBIT.push(this.iznos_kamate_god[i] + this.neto_dobit[i] * 1.25); // prvo fin. rashodi kao i gore
                }

                //this.ekonomicnost.push(this.godisnja_usteda / this.fin_rashodi[i]);
                this.EBITDA.push(this.god_amortizacija + this.EBIT[i]);

                this.brutoProfMrez.push((this.neto_dobit[i] * 1.25) / this.godisnja_usteda);
                this.netoProfMrez.push(this.neto_dobit[i] / this.godisnja_usteda);

                if (i === 0) {
                    this.ulaganje_imovina.push(this.uk_bez_PDV - this.god_amortizacija);

                    if (i >= this.rok_otplate) {
                        this.dug.push(this.kredit - (this.anuitet * 12 - 0));
                    } else {
                        this.dug.push(this.kredit - (this.anuitet * 12 - this.iznos_kamate_god[i]));
                    }
                } else {
                    this.ulaganje_imovina.push(this.ulaganje_imovina[i - 1] - this.god_amortizacija);
                    if (i >= this.rok_otplate) {
                        this.dug.push(this.dug[i - 1] - (this.anuitet * 12 - 0));
                    } else {
                        this.dug.push(this.dug[i - 1] - (this.anuitet * 12 - this.iznos_kamate_god[i]));
                    }
                }

                this.nnt.push(this.god_amortizacija + this.iznos_kamate_god[i] + this.godisnja_usteda);
                this.dostatnostNNT.push(this.nnt - this.anuitet * 12);

            }

            this.doneCalculate = !this.doneCalculate;

            this.calculatePovratByYear();
            this.calculateRoaByYear();

            Vue.nextTick(() => {
                this.scrollToElement();
            })

        },

        scrollToElement() {
            const el = this.$el.getElementsByClassName('rezultat')[0];

            if (el) {
                el.scrollIntoView();
            }
        },

        PMT: function (kamata, broj_uplata, pocetni_iznos) {

            var eksponent = Math.pow(1 + kamata, broj_uplata);
            var pmt = -(kamata / (eksponent - 1) * -(pocetni_iznos * eksponent + 0)); // nula je tu jer inače ide future value koji označuje na kolikom iznosu želimo biti nakon navedenog razdoblja, a to je 0

            return pmt;
        },

        calculatePovratByYear() {
            for (let i = 0; i < 15; i++) {
                if (i === 0) {
                    this.povrat[i] = [
                        i + 1,
                        (this.neto_dobit[i] - this.uk_bez_PDV)
                    ];
                } else {
                    this.povrat[i] = [
                        i + 1,
                        (this.povrat[i - 1][1] + this.neto_dobit[i])
                    ];
                }
            }
        },

        calculateRoaByYear() {
            for (let i = 0; i < 15; i++) {
                if (i === 0) {
                    this.roa[i] = [
                        i + 1,
                        (this.neto_dobit[i] / this.uk_bez_PDV) * 100
                    ]
                } else {
                    this.roa[i] = [
                        i + 1,
                        (this.neto_dobit[i] / this.ulaganje_imovina[i - 1]) * 100
                    ]
                }
            }
        },

        clearForm() {
            this.doneCalculate = false;
            this.snagaElektrane = null;
            this.cijena_oprema = null;
            this.procjena_troskova = null;

            this.potrebnaPovKrova = null;
            this.iskoristivaPovKrova = null;
            this.zakSnagaObjekta = null;
            this.godPotrosnja = null; 
            this.subvencija = null;
            this.odabranaSubvencija = null;

            this.iznos_kredita = null;
            this.kam_stopa = null;
            this.rok_otplate = null;
            this.amort_razd = 15;
            this.ukupno = null;
            this.uk_bez_PDV = null;
            this.uk_PDV = null;

            this.godisnja_usteda= null;
            this.troskoviOpskrbNeto= null;
            this.troskoviOpskrbBruto= null;
            this.razlikaZaNaplatu= null;

            this.god_amortizacija= null;
            
            this.anuitet = 0;
            this.iznos_kamate_god = [];
            this.fin_rashodi= null;
            this.neto_dobit = [];
            this.ekonomicnost = [];
            this.EBIT = [];
            this.EBITDA = [];
            this.brutoProfMrez = [];
            this.netoProfMrez = [];
            this.ulaganje_imovina = [];
            this.dug = [];
            this.roa = [];
            this.povrat = [];
            this.nnt = [];
            this.dostatnostNNT = [];
            this.AAR= null;
            this.AARR= null;
            this.NPV= null;
        }
    },
    watch: {
        snagaElektrane() {
            this.calculateValues();
        },
        iskoristivaPovKrova() {
            this.provjeraKrova();
        },
        odabranaSubvencija() {
            this.subvencijaIznos();
        },
        iznos_kredita() {
            this.provjeraKredita();
        }
    }
};
</script>
